"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Acl () {
        return Acl;
    },
    get AclMiddleware () {
        return AclMiddleware;
    },
    get ExtractIdsMiddleware () {
        return ExtractIdsMiddleware;
    },
    get VIEW_KEY () {
        return _extractidshelpers.VIEW_KEY;
    },
    get getRolesLabels () {
        return getRolesLabels;
    },
    get rolesLabel () {
        return rolesLabel;
    }
});
const _common = require("@nestjs/common");
const _core = require("@nestjs/core");
const _nocodbsdk = require("nocodb-sdk");
const _rxjs = require("rxjs");
const _RowColorCondition = /*#__PURE__*/ _interop_require_default(require("src/models/RowColorCondition"));
const _extractidshelpers = require("./extract-ids.helpers");
const _models = require("~/models");
const _acl = /*#__PURE__*/ _interop_require_wildcard(require("~/utils/acl"));
const _catchError = require("~/helpers/catchError");
const _globalguard = require("~/guards/global/global.guard");
const _jwtstrategy = require("~/strategies/jwt.strategy");
const _globals = require("~/utils/globals");
const _MCPToken = /*#__PURE__*/ _interop_require_default(require("~/models/MCPToken"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const rolesLabel = {
    [_nocodbsdk.OrgUserRoles.SUPER_ADMIN]: 'Super Admin',
    [_nocodbsdk.OrgUserRoles.CREATOR]: 'Org Creator',
    [_nocodbsdk.OrgUserRoles.VIEWER]: 'Org Viewer',
    [_nocodbsdk.WorkspaceUserRoles.OWNER]: 'Workspace Owner',
    [_nocodbsdk.WorkspaceUserRoles.CREATOR]: 'Workspace Creator',
    [_nocodbsdk.WorkspaceUserRoles.VIEWER]: 'Workspace Viewer',
    [_nocodbsdk.WorkspaceUserRoles.EDITOR]: 'Workspace Editor',
    [_nocodbsdk.WorkspaceUserRoles.COMMENTER]: 'Workspace Commenter',
    [_nocodbsdk.ProjectRoles.OWNER]: 'Base Owner',
    [_nocodbsdk.ProjectRoles.CREATOR]: 'Base Creator',
    [_nocodbsdk.ProjectRoles.VIEWER]: 'Base Viewer',
    [_nocodbsdk.ProjectRoles.EDITOR]: 'Base Editor',
    [_nocodbsdk.ProjectRoles.COMMENTER]: 'Base Commenter'
};
function getRolesLabels(roles) {
    return roles.filter((role)=>![
            _nocodbsdk.OrgUserRoles.CREATOR,
            _nocodbsdk.OrgUserRoles.VIEWER
        ].includes(role)).map((role)=>rolesLabel[role]);
}
const getApiVersionFromUrl = (url)=>{
    if (url.startsWith('/api/v3')) return _nocodbsdk.NcApiVersion.V3;
    else if (url.startsWith('/api/v2')) return _nocodbsdk.NcApiVersion.V2;
    else if (url.startsWith('/api/v1')) return _nocodbsdk.NcApiVersion.V1;
    return undefined;
};
let ExtractIdsMiddleware = class ExtractIdsMiddleware {
    async use(req, res, next) {
        var _req_path;
        const { params, query } = req;
        req.ncApiVersion = getApiVersionFromUrl(req.route.path);
        req.ncSocketId = req.headers['xc-socket-id'];
        const bypassContext = {
            workspace_id: _globals.RootScopes.BYPASS,
            base_id: _globals.RootScopes.BYPASS,
            api_version: req.ncApiVersion,
            socket_id: req.ncSocketId
        };
        // this is a special route for ws operations we pass 'nc' as base id
        const isInternalApi = !!((_req_path = req.path) == null ? void 0 : _req_path.startsWith('/api/v2/internal'));
        const isInternalWorkspaceScope = isInternalApi && params.baseId === 'nc';
        const baseId = params.baseId || params.baseName;
        if (!isInternalWorkspaceScope && baseId) {
            const base = await _models.Base.get(bypassContext, baseId);
            if (!base) {
                _catchError.NcError.get(bypassContext).baseNotFound(baseId);
            }
            const context = {
                workspace_id: base.fk_workspace_id,
                base_id: base.id,
                api_version: req.ncApiVersion,
                socket_id: req.ncSocketId
            };
            req.ncBaseId = base.id;
            req.ncWorkspaceId = base.fk_workspace_id;
            req.context = {
                workspace_id: req.ncWorkspaceId,
                base_id: req.ncBaseId,
                api_version: req.ncApiVersion,
                socket_id: req.ncSocketId,
                nc_site_url: req.ncSiteUrl,
                permissions: []
            };
            let view;
            const mcpTokenId = params.mcpTokenId || query.mcpTokenId;
            const integrationId = params.integrationId || query.integrationId;
            const tableId = params.tableId || params.modelId || params.tableName || query.tableId;
            const viewId = params.viewId || params.viewName || query.viewId;
            const formViewId = params.formViewId || query.formViewId;
            const gridViewId = params.gridViewId || query.gridViewId;
            const kanbanViewId = params.kanbanViewId || query.kanbanViewId;
            const galleryViewId = params.galleryViewId || query.galleryViewId;
            const calendarViewId = params.calendarViewId || query.calendarViewId;
            const publicDataUuid = params.publicDataUuid || query.publicDataUuid;
            const sharedViewUuid = params.sharedViewUuid || query.sharedViewUuid;
            const sharedBaseUuid = params.sharedBaseUuid || query.sharedBaseUuid;
            const hookId = params.hookId || query.hookId;
            const buttonColId = params.buttonColId || query.buttonColId;
            const rowColorConditionId = params.rowColorConditionId || query.rowColorConditionId;
            const gridViewColumnId = params.gridViewColumnId || query.gridViewColumnId;
            const formViewColumnId = params.formViewColumnId || query.formViewColumnId;
            const galleryViewColumnId = params.galleryViewColumnId || query.galleryViewColumnId;
            const columnId = params.columnId || query.columnId;
            const filterId = params.filterId || query.filterId;
            const filterParentId = params.filterParentId || query.filterParentId;
            const widgetId = params.widgetId || query.widgetId;
            const sectionId = params.sectionId || query.sectionId;
            const sortId = params.sortId || query.sortId;
            const syncId = params.syncId || query.syncId;
            const extensionId = params.extensionId || query.extensionId;
            if (mcpTokenId) {
                const mcpToken = await _MCPToken.default.get({
                    workspace_id: _globals.RootScopes.FULL_BYPASS,
                    base_id: _globals.RootScopes.FULL_BYPASS
                }, mcpTokenId);
                if (!mcpToken) {
                    _catchError.NcError.get(context).genericNotFound('MCPToken', mcpTokenId);
                }
                req.ncBaseId = mcpToken.base_id;
                req.ncWorkspaceId = mcpToken.fk_workspace_id;
            } else if (integrationId) {
                const integration = await _models.Integration.get(context, integrationId);
                if (!integration) {
                    _catchError.NcError.get(context).integrationNotFound(integrationId);
                }
            } else if (tableId) {
                const model = await _models.Model.get(context, tableId);
                if (!model) {
                    _catchError.NcError.get(context).tableNotFound(tableId);
                }
                req.ncSourceId = model.source_id;
            } else if (viewId) {
                const view = await _models.View.get(context, viewId) || await _models.Model.get(context, viewId);
                if (!view) {
                    _catchError.NcError.get(context).viewNotFound(viewId);
                }
                req.ncSourceId = view.source_id;
                (0, _extractidshelpers.markPersonalViewIfNeeded)(req, view);
            } else if (formViewId || gridViewId || kanbanViewId || galleryViewId || calendarViewId) {
                const view = await _models.View.get(context, formViewId || gridViewId || kanbanViewId || galleryViewId || calendarViewId);
                if (!view) {
                    _catchError.NcError.get(context).viewNotFound(formViewId || gridViewId || kanbanViewId || galleryViewId || calendarViewId);
                }
                req.ncSourceId = view.source_id;
                (0, _extractidshelpers.markPersonalViewIfNeeded)(req, view);
            } else if (publicDataUuid) {
                const view = await _models.View.getByUUID(context, publicDataUuid);
                if (!view) {
                    _catchError.NcError.get(context).viewNotFound(publicDataUuid);
                }
                req.ncSourceId = view == null ? void 0 : view.source_id;
            } else if (sharedViewUuid) {
                const view = await _models.View.getByUUID(context, sharedViewUuid);
                if (!view) {
                    _catchError.NcError.get(context).viewNotFound(sharedViewUuid);
                }
                req.ncSourceId = view.source_id;
            } else if (sharedBaseUuid) {
                const base = await _models.Base.getByUuid(context, sharedBaseUuid);
                if (!base) {
                    _catchError.NcError.get(context).baseNotFound(sharedBaseUuid);
                }
            } else if (hookId) {
                const hook = await _models.Hook.get(context, hookId);
                if (!hook) {
                    _catchError.NcError.get(context).genericNotFound('Webhook', hookId);
                }
                req.ncSourceId = hook.source_id;
            } else if (buttonColId) {
                const column = await _models.Column.get(context, {
                    colId: buttonColId
                });
                if (!column) {
                    _catchError.NcError.get(context).fieldNotFound(buttonColId);
                }
                req.ncSourceId = column.source_id;
            } else if (rowColorConditionId) {
                const rowColorCondition = await _RowColorCondition.default.getById(context, rowColorConditionId);
                if (!rowColorCondition) {
                    _catchError.NcError.get(context).genericNotFound('Row color condition', rowColorConditionId);
                }
                const view = await _models.View.get(context, rowColorCondition.fk_view_id);
                req.ncSourceId = view.source_id;
            } else if (gridViewColumnId) {
                const gridViewColumn = await _models.GridViewColumn.get(context, gridViewColumnId);
                if (!gridViewColumn) {
                    _catchError.NcError.get(context).fieldNotFound(gridViewColumnId);
                }
                req.ncSourceId = gridViewColumn == null ? void 0 : gridViewColumn.source_id;
                if (gridViewColumn == null ? void 0 : gridViewColumn.fk_view_id) {
                    view = await _models.View.get(context, gridViewColumn.fk_view_id);
                }
            } else if (formViewColumnId) {
                const formViewColumn = await _models.FormViewColumn.get(context, formViewColumnId);
                if (!formViewColumn) {
                    _catchError.NcError.get(context).fieldNotFound(formViewColumnId);
                }
                req.ncSourceId = formViewColumn.source_id;
                if (formViewColumn == null ? void 0 : formViewColumn.fk_view_id) {
                    view = await _models.View.get(context, formViewColumn.fk_view_id);
                }
            } else if (galleryViewColumnId) {
                const galleryViewColumn = await _models.GalleryViewColumn.get(context, galleryViewColumnId);
                if (!galleryViewColumn) {
                    _catchError.NcError.get(context).fieldNotFound(galleryViewColumnId);
                }
                req.ncSourceId = galleryViewColumn.source_id;
                if (galleryViewColumn == null ? void 0 : galleryViewColumn.fk_view_id) {
                    view = await _models.View.get(context, galleryViewColumn.fk_view_id);
                }
            } else if (columnId) {
                const column = await _models.Column.get(context, {
                    colId: columnId
                });
                if (!column) {
                    _catchError.NcError.get(context).fieldNotFound(columnId);
                }
                req.ncSourceId = column.source_id;
            } else if (filterId) {
                const filter = await _models.Filter.get(context, filterId);
                if (!filter) {
                    _catchError.NcError.genericNotFound('Filter', filterId);
                }
                if (filter.fk_view_id) {
                    view = await _models.View.get(context, filter.fk_view_id);
                }
                req.ncSourceId = filter.source_id;
            } else if (filterParentId) {
                const filter = await _models.Filter.get(context, filterParentId);
                if (!filter) {
                    _catchError.NcError.genericNotFound('Filter', filterParentId);
                }
                if (filter.fk_view_id) {
                    view = await _models.View.get(context, filter.fk_view_id);
                }
                req.ncSourceId = filter.source_id;
            } else if (widgetId) {
                const widget = await _models.Widget.get(context, widgetId);
                if (!widget) {
                    _catchError.NcError.genericNotFound('Widget', widgetId);
                }
            } else if (sectionId) {
                const section = await _models.ViewSection.get(context, sectionId);
                if (!section) {
                    _catchError.NcError.viewSectionNotFound(sectionId);
                }
                req.ncSourceId = section.source_id;
            } else if (sortId) {
                const sort = await _models.Sort.get(context, sortId);
                if (!sort) {
                    _catchError.NcError.genericNotFound('Sort', sortId);
                }
                if (sort.fk_view_id) {
                    view = await _models.View.get(context, sort.fk_view_id);
                }
                req.ncSourceId = sort.source_id;
            } else if (syncId) {
                const syncSource = await _models.SyncSource.get(context, syncId);
                if (!syncSource) {
                    _catchError.NcError.genericNotFound('Sync Source', syncId);
                }
                req.ncSourceId = syncSource.source_id;
            } else if (extensionId) {
                const extension = await _models.Extension.get(context, extensionId);
                if (!extension) {
                    _catchError.NcError.genericNotFound('Extension', extensionId);
                }
            }
            (0, _extractidshelpers.markPersonalViewIfNeeded)(req, view);
        } else {
            await this.legacyExtractIds(req);
        }
        await this.additionalValidation({
            req,
            res,
            next
        });
        next();
    }
    async canActivate(context) {
        await this.use(context.switchToHttp().getRequest(), context.switchToHttp().getResponse(), ()=>{});
        return true;
    }
    // additional validation logic which can be overridden
    async additionalValidation(_param) {
    // do nothing
    }
    async legacyExtractIds(req) {
        var _req_query, _req_path, _req_body, _req_user;
        const { params } = req;
        let view;
        let tableIdToCheck = null; // Store table ID for permission check at the end
        const context = {
            workspace_id: _globals.RootScopes.BYPASS,
            base_id: _globals.RootScopes.BYPASS,
            api_version: getApiVersionFromUrl(req.route.path),
            socket_id: req.headers['xc-socket-id'],
            timezone: (_req_query = req.query) == null ? void 0 : _req_query.whereTz
        };
        req.ncApiVersion = context.api_version;
        req.ncSocketId = context.socket_id;
        // this is a special route for ws operations we pass 'nc' as base id
        const isInternalApi = !!((_req_path = req.path) == null ? void 0 : _req_path.startsWith('/api/v2/internal'));
        const isInternalWorkspaceScope = isInternalApi && params.baseId === 'nc';
        const isInternalOrgScope = isInternalApi && params.workspaceId === 'nc';
        // We don't extract ncBaseId here intentionally to keep single source of truth
        if (!(isInternalWorkspaceScope || isInternalOrgScope) && (params.baseId || params.baseName)) {
            var _params_baseId;
            // We only allow base id to be used for EE edition
            const base = await _models.Base.get(context, (_params_baseId = params.baseId) != null ? _params_baseId : params.baseName);
            if (!base) {
                var _params_baseId1;
                _catchError.NcError.get(context).baseNotFound((_params_baseId1 = params.baseId) != null ? _params_baseId1 : params.baseName);
            }
            if (params.tableId || params.modelId) {
                const model = await _models.Model.getByIdOrName({
                    workspace_id: base.fk_workspace_id,
                    base_id: base.id
                }, {
                    id: params.tableId || params.modelId,
                    base_id: base.id
                });
                if (!model) {
                    _catchError.NcError.get(context).tableNotFound(params.tableId || params.modelId);
                }
            }
        }
        if (params.mcpTokenId) {
            const mcpToken = await _MCPToken.default.get(context, params.mcpTokenId);
            if (!mcpToken) {
                _catchError.NcError.get(context).genericNotFound('MCPToken', params.mcpTokenId);
            }
            req.ncBaseId = mcpToken.base_id;
            req.ncWorkspaceId = mcpToken.fk_workspace_id;
        } else if (params.baseId && !(isInternalWorkspaceScope || isInternalOrgScope)) {
            req.ncBaseId = params.baseId;
        } else if (params.integrationId) {
            const integration = await _models.Integration.get(context, params.integrationId);
            if (!integration) {
                _catchError.NcError.get(context).integrationNotFound(params.integrationId);
            }
            req.ncWorkspaceId = integration.fk_workspace_id;
        } else if (params.tableId || params.modelId) {
            const model = await _models.Model.getByIdOrName(context, {
                id: params.tableId || params.modelId
            });
            if (!model) {
                _catchError.NcError.get(context).tableNotFound(params.tableId || params.modelId);
            }
            req.ncBaseId = model.base_id;
            req.ncSourceId = model.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = model.id;
        } else if (params.viewId) {
            view = await _models.View.get(context, params.viewId) || await _models.Model.get(context, params.viewId);
            if (!view) {
                _catchError.NcError.get(context).viewNotFound(params.viewId);
            }
            req.ncBaseId = view.base_id;
            req.ncSourceId = view.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = view == null ? void 0 : view.fk_model_id;
        } else if (params.formViewId || params.gridViewId || params.kanbanViewId || params.galleryViewId || params.calendarViewId) {
            view = await _models.View.get(context, params.formViewId || params.gridViewId || params.kanbanViewId || params.galleryViewId || params.calendarViewId);
            if (!view) {
                _catchError.NcError.get(context).viewNotFound(params.formViewId || params.gridViewId || params.kanbanViewId || params.galleryViewId || params.calendarViewId);
            }
            req.ncBaseId = view.base_id;
            req.ncSourceId = view.source_id;
        } else if (params.publicDataUuid) {
            const view = await _models.View.getByUUID(context, req.params.publicDataUuid);
            if (!view) {
                _catchError.NcError.get(context).viewNotFound(req.params.publicDataUuid);
            }
            req.ncBaseId = view == null ? void 0 : view.base_id;
            req.ncSourceId = view == null ? void 0 : view.source_id;
        } else if (params.sharedViewUuid) {
            const view = await _models.View.getByUUID(context, req.params.sharedViewUuid);
            if (!view) {
                _catchError.NcError.get(context).viewNotFound(req.params.sharedViewUuid);
            }
            req.ncBaseId = view.base_id;
            req.ncSourceId = view.source_id;
        } else if (params.sharedBaseUuid) {
            const base = await _models.Base.getByUuid(context, req.params.sharedBaseUuid);
            if (!base) {
                _catchError.NcError.get(context).baseNotFound(req.params.sharedBaseUuid);
            }
            req.ncBaseId = base == null ? void 0 : base.id;
        } else if (params.hookId) {
            const hook = await _models.Hook.get(context, params.hookId);
            if (!hook) {
                _catchError.NcError.get(context).genericNotFound('Webhook', params.hookId);
            }
            req.ncBaseId = hook.base_id;
            req.ncSourceId = hook.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = hook.fk_model_id;
        } else if (params.rowColorConditionId) {
            const rowColorCondition = await _RowColorCondition.default.getById(context, params.rowColorConditionId);
            if (!rowColorCondition) {
                _catchError.NcError.get(context).genericNotFound('Row color condition', params.rowColorConditionId);
            }
            req.ncBaseId = rowColorCondition.base_id;
            view = await _models.View.get(context, rowColorCondition.fk_view_id);
            req.ncSourceId = view.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = view == null ? void 0 : view.fk_model_id;
        } else if (params.gridViewColumnId) {
            const gridViewColumn = await _models.GridViewColumn.get(context, params.gridViewColumnId);
            if (!gridViewColumn) {
                _catchError.NcError.get(context).fieldNotFound(params.gridViewColumnId);
            }
            if (gridViewColumn.fk_view_id) {
                view = await _models.View.get(context, gridViewColumn.fk_view_id);
            }
            req.ncBaseId = gridViewColumn == null ? void 0 : gridViewColumn.base_id;
            req.ncSourceId = gridViewColumn == null ? void 0 : gridViewColumn.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.formViewColumnId) {
            const formViewColumn = await _models.FormViewColumn.get(context, params.formViewColumnId);
            if (!formViewColumn) {
                _catchError.NcError.get(context).fieldNotFound(params.formViewColumnId);
            }
            if (formViewColumn.fk_view_id) {
                view = await _models.View.get(context, formViewColumn.fk_view_id);
            }
            req.ncBaseId = formViewColumn.base_id;
            req.ncSourceId = formViewColumn.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.galleryViewColumnId) {
            const galleryViewColumn = await _models.GalleryViewColumn.get(context, params.galleryViewColumnId);
            if (!galleryViewColumn) {
                _catchError.NcError.get(context).fieldNotFound(params.galleryViewColumnId);
            }
            if (galleryViewColumn.fk_view_id) {
                view = await _models.View.get(context, galleryViewColumn.fk_view_id);
            }
            req.ncBaseId = galleryViewColumn.base_id;
            req.ncSourceId = galleryViewColumn.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.columnId) {
            const column = await _models.Column.get(context, {
                colId: params.columnId
            });
            if (!column) {
                _catchError.NcError.get(context).fieldNotFound(params.columnId);
            }
            req.ncBaseId = column.base_id;
            req.ncSourceId = column.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = column.fk_model_id;
        } else if (params.filterId) {
            const filter = await _models.Filter.get(context, params.filterId);
            if (!filter) {
                _catchError.NcError.genericNotFound('Filter', params.filterId);
            }
            if (filter.fk_view_id) {
                view = await _models.View.get(context, filter.fk_view_id);
            }
            req.ncBaseId = filter.base_id;
            req.ncSourceId = filter.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.filterParentId) {
            const filter = await _models.Filter.get(context, params.filterParentId);
            if (!filter) {
                _catchError.NcError.genericNotFound('Filter', params.filterParentId);
            }
            if (filter.fk_view_id) {
                view = await _models.View.get(context, filter.fk_view_id);
            }
            req.ncBaseId = filter.base_id;
            req.ncSourceId = filter.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.widgetId) {
            const widget = await _models.Widget.get(context, params.widgetId);
            if (!widget) {
                _catchError.NcError.genericNotFound('Widget', params.widgetId);
            }
            req.ncBaseId = widget.base_id;
        } else if (params.sectionId) {
            const section = await _models.ViewSection.get(context, params.sectionId);
            if (!section) {
                _catchError.NcError.viewSectionNotFound(params.sectionId);
            }
            req.ncBaseId = section.base_id;
            req.ncSourceId = section.source_id;
            if (section.fk_model_id) {
                tableIdToCheck = section.fk_model_id;
            }
        } else if (params.sortId) {
            const sort = await _models.Sort.get(context, params.sortId);
            if (!sort) {
                _catchError.NcError.genericNotFound('Sort', params.sortId);
            }
            if (sort.fk_view_id) {
                view = await _models.View.get(context, sort.fk_view_id);
            }
            req.ncBaseId = sort.base_id;
            req.ncSourceId = sort.source_id;
            // Extract table ID for permission check at the end
            if (view == null ? void 0 : view.fk_model_id) {
                tableIdToCheck = view.fk_model_id;
            }
        } else if (params.syncId) {
            const syncSource = await _models.SyncSource.get(context, req.params.syncId);
            if (!syncSource) {
                _catchError.NcError.genericNotFound('Sync Source', req.params.syncId);
            }
            req.ncBaseId = syncSource.base_id;
            req.ncSourceId = syncSource.source_id;
        } else if (params.extensionId) {
            const extension = await _models.Extension.get(context, req.params.extensionId);
            if (!extension) {
                _catchError.NcError.genericNotFound('Extension', req.params.extensionId);
            }
            req.ncBaseId = extension.base_id;
        } else if ([
            '/api/v1/db/meta/comments',
            '/api/v2/meta/comments'
        ].some((auditInsertOrUpdatePath)=>req.route.path === auditInsertOrUpdatePath) && req.method === 'POST' && ((_req_body = req.body) == null ? void 0 : _req_body.fk_model_id)) {
            const model = await _models.Model.getByIdOrName(context, {
                id: req.body.fk_model_id
            });
            if (!model) {
                _catchError.NcError.get(context).tableNotFound(req.body.fk_model_id);
            }
            req.ncBaseId = model.base_id;
            req.ncSourceId = model.source_id;
        } else if ([
            '/api/v2/meta/comments/count',
            '/api/v1/db/meta/comments/count',
            '/api/v2/meta/comments',
            '/api/v1/db/meta/comments'
        ].some((auditReadPath)=>req.route.path === auditReadPath) && req.method === 'GET' && req.query.fk_model_id) {
            var _req_query1;
            const model = await _models.Model.getByIdOrName(context, {
                id: (_req_query1 = req.query) == null ? void 0 : _req_query1.fk_model_id
            });
            if (!model) {
                var _req_query2;
                _catchError.NcError.get(context).tableNotFound((_req_query2 = req.query) == null ? void 0 : _req_query2.fk_model_id);
            }
            req.ncBaseId = model.base_id;
            req.ncSourceId = model.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = model.id;
        } else if ([
            '/api/v1/db/meta/comment/:commentId',
            '/api/v2/meta/comment/:commentId',
            '/api/v1/db/meta/comment/:commentId/resolve',
            '/api/v2/meta/comment/:commentId/resolve'
        ].some((auditPatchPath)=>req.route.path === auditPatchPath) && (req.method === 'PATCH' || req.method === 'DELETE' || req.method === 'POST') && req.params.commentId) {
            const audit = await _models.Comment.get(context, params.commentId);
            if (!audit) {
                _catchError.NcError.genericNotFound('Comment', params.commentId);
            }
            req.ncBaseId = audit.base_id;
            req.ncSourceId = audit.source_id;
            // Extract table ID for permission check at the end
            tableIdToCheck = audit.fk_model_id;
        } else if ([
            '/auth/user/me',
            '/api/v1/db/auth/user/me',
            '/api/v1/auth/user/me'
        ].some((userMePath)=>req.route.path === userMePath) && (req.query.base_id || req.query.workspace_id)) {
            // use base to get workspace id if base id is provided
            if (req.query.base_id) {
                req.ncBaseId = req.query.base_id;
            } else {
                req.ncWorkspaceId = req.query.workspace_id;
            }
        }
        // todo:  verify all scenarios
        // extract workspace id based on request path params or
        // extract base id based on request path params
        if ((params.baseId || params.baseName) && !req.ncBaseId && !(isInternalWorkspaceScope || isInternalOrgScope)) {
            var _params_baseId2;
            // we expect project_name to be id for EE
            const base = await _models.Base.get(context, (_params_baseId2 = params.baseId) != null ? _params_baseId2 : params.baseName);
            if (base) {
                req.ncBaseId = base.id;
                req.ncWorkspaceId = base.fk_workspace_id;
                if (req.params.tableName) {
                    // extract model and then source id from model
                    const model = await _models.Model.getByAliasOrId(context, {
                        base_id: base.id,
                        aliasOrId: req.params.tableName
                    });
                    if (!model) {
                        _catchError.NcError.get(context).tableNotFound(req.params.tableName);
                    }
                    req.ncSourceId = model == null ? void 0 : model.source_id;
                }
            } else {
                var _params_baseId3;
                _catchError.NcError.baseNotFound((_params_baseId3 = params.baseId) != null ? _params_baseId3 : params.baseName);
            }
        } else if (req.ncBaseId && !(isInternalWorkspaceScope || isInternalOrgScope)) {
            const base = await _models.Base.get(context, req.ncBaseId);
            if (base) {
                req.ncWorkspaceId = base.fk_workspace_id;
            } else {
                _catchError.NcError.baseNotFound(req.ncBaseId);
            }
        } else if (req.params.workspaceId && !isInternalOrgScope) {
            req.ncWorkspaceId = req.params.workspaceId;
        } else if (req.params.workspaceOrOrgId) {
            const workspace = await _models.Workspace.get(req.params.workspaceOrOrgId);
            if (workspace) {
                req.ncWorkspaceId = workspace.id;
                req.ncWorkspace = workspace;
            } else {
                req.ncOrgId = req.params.workspaceOrOrgId;
            }
        } else if ([
            '/api/v2/meta/bases',
            '/api/v1/db/meta/projects'
        ].some((baseCreatePath)=>req.route.path === baseCreatePath) && req.method === 'POST' && req.body.fk_workspace_id) {
            req.ncWorkspaceId = req.body.fk_workspace_id;
        }
        // if integration list endpoint is called with baseId, then extract baseId if it's valid
        if (req.route.path === '/api/v2/meta/workspaces/:workspaceId/integrations' && req.method === 'GET' && req.query.baseId) {
            // check if baseId is valid and under the workspace
            const base = await _models.Base.get(context, req.query.baseId);
            if (!base || base.fk_workspace_id !== req.ncWorkspaceId) {
                _catchError.NcError.baseNotFound(req.query.baseId);
            }
            req.ncBaseId = base.id;
        }
        // When viewId is present but wasn't the primary entity in the if-else
        // chain (e.g., internal API with viewId/filterId/sortId/viewColumnId
        // in query params), extract the view for personal-view permission checks.
        if (!view && (params.viewId || req.query.viewId)) {
            const viewFromId = await _models.View.get(context, params.viewId || req.query.viewId);
            if (viewFromId instanceof _models.View) {
                view = viewFromId;
            }
        } else if (!view && req.query.filterId) {
            const filter = await _models.Filter.get(context, req.query.filterId);
            if (filter == null ? void 0 : filter.fk_view_id) {
                const viewFromFilter = await _models.View.get(context, filter.fk_view_id);
                if (viewFromFilter instanceof _models.View) {
                    view = viewFromFilter;
                }
            }
        } else if (!view && req.query.sortId) {
            const sort = await _models.Sort.get(context, req.query.sortId);
            if (sort == null ? void 0 : sort.fk_view_id) {
                const viewFromSort = await _models.View.get(context, sort.fk_view_id);
                if (viewFromSort instanceof _models.View) {
                    view = viewFromSort;
                }
            }
        }
        (0, _extractidshelpers.markPersonalViewIfNeeded)(req, view);
        if (!req.ncWorkspaceId) {
            req.ncWorkspaceId = _Noco.default.ncDefaultWorkspaceId;
        }
        req.context = {
            org_id: req.ncOrgId,
            workspace_id: req.ncWorkspaceId,
            base_id: req.ncBaseId,
            api_version: context.api_version,
            socket_id: req.headers['xc-socket-id'],
            nc_site_url: req.ncSiteUrl,
            timezone: context.timezone,
            is_api_token: (_req_user = req.user) == null ? void 0 : _req_user.is_api_token,
            permissions: []
        };
        // Store table ID to check in context for ACL middleware to perform table visibility check
        if (tableIdToCheck) {
            req.context.ncTableId = tableIdToCheck;
        }
    }
};
ExtractIdsMiddleware = _ts_decorate([
    (0, _common.Injectable)()
], ExtractIdsMiddleware);
// todo: refactor and move scope name to enum
function getUserRoleForScope(user, scope) {
    if (scope === 'workspace') {
        return user == null ? void 0 : user.workspace_roles;
    } else if (scope === 'base') {
        return user == null ? void 0 : user.base_roles;
    } else if (scope === 'cloud-org') {
        return user == null ? void 0 : user.org_roles;
    } else if (scope === 'org') {
        return user == null ? void 0 : user.roles;
    }
}
let AclMiddleware = class AclMiddleware {
    async aclFn(permissionName, { scope = 'base', allowedRoles, blockApiTokenAccess, extendedScope } = {}, context, req) {
        var _req_user, _req_VIEW_KEY, _req_user1, _req_user2, _req_user_roles, _req_user3, _req_user_workspace_roles, _req_user4, _req_params, _req_params1, _req_params2, _req_user5;
        // if user is not defined then run GlobalGuard
        // it's to take care if we are missing @UseGuards(GlobalGuard) in controller
        // todo: later we can move guard part to this middleware or add where it's missing
        if (!req.user) {
            try {
                const guard = new _globalguard.GlobalGuard(this.jwtStrategy);
                await guard.canActivate(context);
            } catch (e) {
                console.log(e);
            }
        }
        if (!((_req_user = req.user) == null ? void 0 : _req_user.isAuthorized)) {
            _catchError.NcError.unauthorized('Invalid token');
        }
        // Block non-owners from modifying filters/sorts on someone else's personal view
        if (((_req_VIEW_KEY = req[_extractidshelpers.VIEW_KEY]) == null ? void 0 : _req_VIEW_KEY.lock_type) === _nocodbsdk.ViewLockType.Personal && req[_extractidshelpers.VIEW_KEY].owned_by !== ((_req_user1 = req.user) == null ? void 0 : _req_user1.id) && _extractidshelpers.personalViewOwnerOnlyOps.includes(permissionName)) {
            _catchError.NcError.forbidden('Unauthorized access');
        }
        const isPersonalViewOwner = (0, _extractidshelpers.checkIsPersonalViewOwner)(req);
        // For editors: restrict filter/sort/view-management operations to personal views they own
        const userBaseRoles = (0, _nocodbsdk.extractRolesObj)((_req_user2 = req.user) == null ? void 0 : _req_user2.base_roles);
        const isEditor = (userBaseRoles == null ? void 0 : userBaseRoles[_nocodbsdk.ProjectRoles.EDITOR]) && !(userBaseRoles == null ? void 0 : userBaseRoles[_nocodbsdk.ProjectRoles.CREATOR]) && !(userBaseRoles == null ? void 0 : userBaseRoles[_nocodbsdk.ProjectRoles.OWNER]);
        if (isEditor && _extractidshelpers.editorPersonalViewOnlyPermissions.includes(permissionName) && !isPersonalViewOwner) {
            _catchError.NcError.forbidden('Unauthorized access');
        }
        const userScopeRole = ((_req_user_roles = req.user.roles) == null ? void 0 : _req_user_roles[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) === true ? _nocodbsdk.OrgUserRoles.SUPER_ADMIN : getUserRoleForScope(req.user, scope);
        // extendedScope is used to allow access based on extended scope in which permission is prefixed with scope name and separated by underscore
        const extendedScopeRoles = extendedScope && getUserRoleForScope(req.user, extendedScope);
        if (!userScopeRole && !extendedScopeRoles) {
            _catchError.NcError.forbidden('Unauthorized access');
        }
        // assign owner role to super admin for all bases
        if (userScopeRole === _nocodbsdk.OrgUserRoles.SUPER_ADMIN) {
            req.user.base_roles = {
                [_nocodbsdk.ProjectRoles.OWNER]: true
            };
        }
        const roles = (0, _nocodbsdk.extractRolesObj)(userScopeRole);
        if ((req == null ? void 0 : (_req_user3 = req.user) == null ? void 0 : _req_user3.is_api_token) && blockApiTokenAccess) {
            _catchError.NcError.apiTokenNotAllowed();
        }
        if ((!allowedRoles || allowedRoles.some((role)=>roles == null ? void 0 : roles[role])) && ![
            extendedScopeRoles,
            roles
        ].some((roles)=>roles && ((roles == null ? void 0 : roles.creator) || (roles == null ? void 0 : roles.owner) || (roles == null ? void 0 : roles.editor) || (roles == null ? void 0 : roles.viewer) || (roles == null ? void 0 : roles.commenter) || (roles == null ? void 0 : roles['no-access']) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.OWNER]) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.CREATOR]) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.EDITOR]) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.VIEWER]) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.COMMENTER]) || (roles == null ? void 0 : roles[_nocodbsdk.WorkspaceUserRoles.NO_ACCESS]) || (roles == null ? void 0 : roles[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) || (roles == null ? void 0 : roles[_nocodbsdk.OrgUserRoles.CREATOR]) || (roles == null ? void 0 : roles[_nocodbsdk.OrgUserRoles.VIEWER]) || (roles == null ? void 0 : roles[_nocodbsdk.CloudOrgUserRoles.CREATOR]) || (roles == null ? void 0 : roles[_nocodbsdk.CloudOrgUserRoles.VIEWER]) || (roles == null ? void 0 : roles[_nocodbsdk.CloudOrgUserRoles.OWNER])))) {
            _catchError.NcError.unauthorized('Unauthorized access');
        }
        // todo : verify user have access to base or not
        // if user have no access role and trying to remove self from workspace then allow it
        const isUserWithNoAccessLeavingWorkspace = permissionName === 'workspaceUserDelete' && req.method === 'DELETE' && ((_req_user4 = req.user) == null ? void 0 : (_req_user_workspace_roles = _req_user4.workspace_roles) == null ? void 0 : _req_user_workspace_roles[_nocodbsdk.WorkspaceUserRoles.NO_ACCESS]) && ((_req_params = req.params) == null ? void 0 : _req_params.workspaceId) && ((_req_params1 = req.params) == null ? void 0 : _req_params1.workspaceUserId) && ((_req_params2 = req.params) == null ? void 0 : _req_params2.workspaceUserId) === ((_req_user5 = req.user) == null ? void 0 : _req_user5.id);
        const isPersonalViewOwnerAllowed = isPersonalViewOwner && _extractidshelpers.personalViewOwnerAllowedPermissions.includes(permissionName);
        const isAllowed = isPersonalViewOwnerAllowed || roles && Object.entries(roles).some(([name, hasRole])=>{
            return hasRole && _acl.default[name] && (_acl.default[name] === '*' || _acl.default[name].exclude && !_acl.default[name].exclude[permissionName] || _acl.default[name].include && _acl.default[name].include[permissionName]);
        }) || // extendedScope is used to allow access based on extended scope in which permission is prefixed with scope name and separated by underscore
        extendedScopeRoles && Object.entries(extendedScopeRoles).some(([name, hasRole])=>{
            return hasRole && _acl.default[name] && (_acl.default[name] === '*' || _acl.default[name].exclude && !_acl.default[name].exclude[scope + '_' + permissionName] || _acl.default[name].include && _acl.default[name].include[scope + '_' + permissionName]);
        }) || isUserWithNoAccessLeavingWorkspace;
        if (!isAllowed) {
            _catchError.NcError.forbidden((0, _acl.generateReadablePermissionErr)(permissionName, roles != null ? roles : extendedScopeRoles, scope));
        // NcError.forbidden(
        //   `${permissionName} - ${getRolesLabels(
        //     Object.keys(roles).filter((k) => roles[k]),
        //   )} : Not allowed`,
        // );
        }
        // check if permission have source level permission restriction
        // 1. Check if it's present in the source restriction list
        // 2. If present, check if write permission is allowed
        if (_acl.sourceRestrictions[_nocodbsdk.SourceRestriction.SCHEMA_READONLY][permissionName] || _acl.sourceRestrictions[_nocodbsdk.SourceRestriction.DATA_READONLY][permissionName]) {
            let source;
            // if tableCreate and source ID is empty, then extract the default source from base
            if (!req.ncSourceId && req.ncBaseId && permissionName === 'tableCreate') {
                const sources = await _models.Source.list(req.context, {
                    baseId: req.ncBaseId
                });
                if (req.params.sourceId) {
                    source = sources.find((s)=>s.id === req.params.sourceId);
                } else {
                    source = sources.find((s)=>s.isMeta()) || sources[0];
                }
            } else if (req.ncSourceId) {
                source = await _models.Source.get(req.context, req.ncSourceId);
            }
            // todo: replace with better error and this is not an expected error
            if (!source) {
                _catchError.NcError.notFound('Source not found or source id not extracted');
            }
            if (source.is_schema_readonly && _acl.sourceRestrictions[_nocodbsdk.SourceRestriction.SCHEMA_READONLY][permissionName]) {
                _catchError.NcError.sourceMetaReadOnly(source.alias);
            }
            if (source.is_data_readonly && _acl.sourceRestrictions[_nocodbsdk.SourceRestriction.DATA_READONLY][permissionName]) {
                _catchError.NcError.sourceDataReadOnly(source.alias);
            }
        }
        if (req.context) {
            req.context.is_api_token = req.user.is_api_token;
        }
    }
    async intercept(context, next) {
        const permissionName = this.reflector.get('permission', context.getHandler());
        const allowedRoles = this.reflector.get('allowedRoles', context.getHandler());
        const blockApiTokenAccess = this.reflector.get('blockApiTokenAccess', context.getHandler());
        const scope = this.reflector.get('scope', context.getHandler());
        const extendedScope = this.reflector.get('extendedScope', context.getHandler());
        const req = context.switchToHttp().getRequest();
        await this.aclFn(permissionName, {
            scope,
            allowedRoles,
            blockApiTokenAccess,
            extendedScope
        }, context, req);
        return next.handle().pipe((0, _rxjs.map)((data)=>{
            return data;
        }));
    }
    constructor(reflector, jwtStrategy){
        this.reflector = reflector;
        this.jwtStrategy = jwtStrategy;
    }
};
AclMiddleware = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _core.Reflector === "undefined" ? Object : _core.Reflector,
        typeof _jwtstrategy.JwtStrategy === "undefined" ? Object : _jwtstrategy.JwtStrategy
    ])
], AclMiddleware);
const Acl = (permissionName, { scope = 'base', allowedRoles, blockApiTokenAccess, extendedScope } = {})=>(target, key, descriptor)=>{
        (0, _common.SetMetadata)('permission', permissionName)(target, key, descriptor);
        (0, _common.SetMetadata)('scope', scope)(target, key, descriptor);
        // extendedScope is used to allow access based on extended scope in which permission is prefixed with scope name and separated by underscore
        (0, _common.SetMetadata)('extendedScope', extendedScope)(target, key, descriptor);
        (0, _common.SetMetadata)('allowedRoles', allowedRoles)(target, key, descriptor);
        (0, _common.SetMetadata)('blockApiTokenAccess', blockApiTokenAccess)(target, key, descriptor);
        (0, _common.UseInterceptors)(AclMiddleware)(target, key, descriptor);
    };
